import { render, staticRenderFns } from "./Announcer.vue?vue&type=template&id=bd3e8676&scoped=true"
import script from "./Announcer.vue?vue&type=script&lang=js"
export * from "./Announcer.vue?vue&type=script&lang=js"
import style0 from "./Announcer.vue?vue&type=style&index=0&id=bd3e8676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3e8676",
  null
  
)

export default component.exports